/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEaseInCuteRe: {
  name: 'ease-in-cute-re';
  data: string;
} = {
  name: 'ease-in-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.664 3.06c-.208.08-.398.229-.497.389-.045.072-.256.581-.47 1.131-1.224 3.151-2.217 5.149-3.598 7.24-1.354 2.052-3.016 3.86-4.599 5.004-1.343.97-2.84 1.642-4.351 1.953-.598.124-1.446.222-1.912.223-.468 0-.709.078-.931.3a.96.96 0 0 0 .001 1.401c.316.316.7.355 2.073.214 3.626-.374 6.962-2.374 9.865-5.915 1.804-2.2 3.514-5.209 4.87-8.569.525-1.302.849-2.169.872-2.335.029-.216-.073-.558-.221-.736-.239-.289-.76-.43-1.102-.3"/></svg>`
};
